import React from 'react'
import EditIcon from '@mui/icons-material/Edit'
import SaveIcon from '@mui/icons-material/Save'
import CancelIcon from '@mui/icons-material/Cancel'
import { IconButtonWithTooltip } from './icon-button-with-tooltip'

interface EditActionsProps {
  entityName: string
  editing: boolean
  onEdit: () => void
  onCancel: () => void
  onSave: () => void
  saving?: boolean
  disabled?: boolean
  saveDisabled?: boolean
  savePlacement?: 'right' | 'left'
  showCancel?: boolean
}

export const EditActions: React.FC<EditActionsProps> = ({
  entityName,
  editing,
  onEdit,
  onCancel,
  onSave,
  saving = false,
  disabled = false,
  saveDisabled = false,
  savePlacement = 'right',
  showCancel = true
}) => {
  if (!editing) {
    return (
      <IconButtonWithTooltip
        label={`Edit ${entityName}`}
        color='primary'
        onClick={onEdit}
        disabled={disabled || saving}
        icon={<EditIcon />}
      />
    )
  }

  const cancel = showCancel
    ? (
      <IconButtonWithTooltip
        label='Cancel Editing'
        color='secondary'
        onClick={onCancel}
        disabled={saving || disabled}
        icon={<CancelIcon />}
      />
      )
    : null

  const save = (
    <IconButtonWithTooltip
      label={`Save ${entityName}`}
      color='primary'
      onClick={onSave}
      disabled={saving || disabled || saveDisabled}
      icon={<SaveIcon />}
    />
  )

  return (
    <>
      {savePlacement === 'left'
        ? <>{save}{cancel}</>
        : <>{cancel}{save}</>}
    </>
  )
}
